#import "../fragments/meeting-for-landing-page.graphql"

query GetMeetingsForLandingPages {
    meetings {
        ...MeetingForLandingPage
    }
}
